export enum ApplicationDataType {
  BRANDS = 'brands',
  DEPARTMENTS = 'departments',
  FORCE_QUANTITIES = 'forceQuantities',
  MINIMAL_LAYERS = 'minimalLayers',
  OPEN_PURCHASE_ORDERS = 'openPurchaseOrders',
  SKU_CLASSES = 'skuClasses',
  SKU_DELIVERY_DATA = 'skuDeliveryData',
}
